import { render, staticRenderFns } from "./ChartGluTable.vue?vue&type=template&id=2c5b3e67&scoped=true"
import script from "./ChartGluTable.vue?vue&type=script&lang=js"
export * from "./ChartGluTable.vue?vue&type=script&lang=js"
import style0 from "./ChartGluTable.vue?vue&type=style&index=0&id=2c5b3e67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5b3e67",
  null
  
)

export default component.exports